
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M3.5 15.5h10"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M3.5 1.5v5.923c0 1.347.527 2.638 1.464 3.59A4.96 4.96 0 0 0 8.5 12.5a4.96 4.96 0 0 0 3.536-1.487 5.12 5.12 0 0 0 1.464-3.59V1.5"}})])])
          )
        }
      }
    